import React from 'react';
import Icon from 'utils/components/icon';
import { Folder, Message, IPageInfo, MessagesCounts } from '../../../state/types';

interface Props {
  isLoading: boolean;
  counts: MessagesCounts;
  folder: Folder;
  activeItems: number;
  itemsList: Message[];
  isModerationMode: boolean;
  changePageInfo: (pageInfo: Partial<IPageInfo>) => any;
}

const EmptyList: React.FC<Props> = ({
  isLoading,
  counts,
  folder,
  activeItems,
  itemsList,
  isModerationMode,
  changePageInfo
}) => {
  let emptyList = null;

  const navigateToAllFolder = () => {
    changePageInfo({ folder: Folder.ALL });
  };

  if (
    isModerationMode &&
    folder === Folder.PENDING &&
    counts[Folder.PENDING] > 0 &&
    itemsList.length === 0
  ) {
    emptyList = (
      <div className="all-locked">
        <Icon className="moderator-icon" name="moderator" />
        <span>
          All pending comments are moderated by <strong>other team members</strong>
        </span>
      </div>
    );
  } else if ((itemsList.length === 0 || activeItems === 0) && !isLoading) {
    emptyList = (
      <div className="empty-folder">
        No results found.
        <br />
        {folder !== Folder.ALL ? (
          <>
            You may find what you are looking for under the <a onClick={navigateToAllFolder}>All</a>{' '}
            tab.
          </>
        ) : null}
      </div>
    );
  }

  return emptyList;
};

export default EmptyList;
